import { cn } from '@worldcoo/ui/lib/utils';
import { WorldcooLogoIcon } from '@worldcoo/ui/custom/worldcoo-logo-icon';

/** Darker than `ink` so the #25302C watermark stands out; the band and the strip under it share it or meet on a seam. */
export const CTA_SURFACE = 'bg-[#1c2824]';

/** Sized off its width, the only dimension stable across the variants (~420px vs ~1050px tall). */
export function CtaWatermark(props: { side: 'left' | 'right' }) {
	// On the mark's own box: a band-sized mask put the form variant's mark entirely in its transparent end.
	const fade = 'new-watermark-fade text-ink absolute h-auto';

	return (
		<div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
			{props.side === 'right' ? (
				<WorldcooLogoIcon className={cn(fade, '-right-[6%] bottom-0 w-[85%] max-w-[1000px]')} />
			) : (
				// Bound to the content box, or the mark drifts under the right-column form as the viewport grows.
				<div className="relative mx-auto h-full max-w-[1440px]">
					<WorldcooLogoIcon className={cn(fade, 'top-1/2 left-0 w-[calc(50%-2.5rem)] -translate-y-1/2')} />
				</div>
			)}
		</div>
	);
}
